import { render, staticRenderFns } from "./addKeCheng.vue?vue&type=template&id=4622e7e0&scoped=true&"
import script from "./addKeCheng.vue?vue&type=script&lang=js&"
export * from "./addKeCheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622e7e0",
  null
  
)

export default component.exports